export const MOVED_CITATIONS_SUCCEEDED = 'MOVED_CITATIONS/MOVED_CITATIONS_SUCCEEDED'
export const MOVED_CITATIONS_CLEARED = 'MOVED_CITATIONS/CLEARED'
